import React, { useState, useEffect, useContext } from 'react';
import Select, { StylesConfig } from 'react-select';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../../../../firebase';
import { CustomerContext } from './CustomerContext';

interface SelectOption {
  label: string;
  value: string;
}

const customSelectStyles: StylesConfig<SelectOption, false> = {
    control: (provided) => ({
      ...provided,
      backgroundColor: 'var(--bs-secondary-bg)',
      borderColor: 'var(--bs-border-color)',
      minHeight: '30px',
      height: '30px',
      boxShadow: 'none',
    }),
    valueContainer: (provided) => ({
      ...provided,
      height: '30px',
      padding: '0 6px',
    }),
    input: (provided) => ({
      ...provided,
      margin: '0px',
      color: 'var(--bs-body-color)',
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      height: '30px',
    }),
    option: (provided, state) => ({
      ...provided,
      color: state.isSelected ? 'var(--bs-body-color)' : 'var(--bs-body-color)',
      backgroundColor: state.isSelected ? 'var(--bs-secondary-bg)' : 'var(--bs-secondary-bg)',
    }),
    singleValue: (provided) => ({
        ...provided,
        color: 'var(--bs-body-color)',
      }),
      menu: (provided) => ({
        ...provided,
        backgroundColor: 'var(--bs-secondary-bg)',
      }),
  };
  

  const ClientSearch: React.FC = () => {
    const context = useContext(CustomerContext);
  
    if (!context) {
      throw new Error('ClientSearch must be used within a CustomerContext Provider');
    }

    const { customerId, setCustomerId, setOpenSearchCard, openSearchCard } = context;
    const [inputValue, setInputValue] = useState('');
    const [customers, setCustomers] = useState<SelectOption[]>([]);
    const [recentSearches, setRecentSearches] = useState<SelectOption[]>(() => {
      const savedSearches = localStorage.getItem('recentSearches');
      return savedSearches ? JSON.parse(savedSearches) : [];
    });

    const handleCustomerChange = (option: SelectOption | null) => {
      const newCustomerId = option ? option.value : null;
      setCustomerId(newCustomerId);
      setOpenSearchCard(false);
      console.log(openSearchCard);
      
  
      if (option) {
        setRecentSearches(prevState => {
          const newState = prevState.filter(search => search.value !== option.value);
          newState.unshift(option);
          const updatedSearches = newState.slice(0, 10); // Keep only the 10 most recent searches
          localStorage.setItem('recentSearches', JSON.stringify(updatedSearches));
          return updatedSearches;
        });
      }
    };

    useEffect(() => {
      console.log(openSearchCard);
    }, [openSearchCard]);
  
    useEffect(() => {
      if (inputValue === '') {
        setCustomers([]);
        return;
      }

      
  
      const fetchCustomers = async () => {
        const customerCollection = collection(db, 'customers');
        const querySnapshot = await getDocs(customerCollection);
        let customerOptions: SelectOption[] = [];
  
        querySnapshot.docs.forEach(doc => {
          const data = doc.data();
          const id = doc.id;
          if (data.company.toLowerCase().includes(inputValue.toLowerCase())) {
            customerOptions.push({ label: data.company, value: id });
          }
          if (data.name.toLowerCase().includes(inputValue.toLowerCase())) {
            customerOptions.push({ label: data.name, value: id });
          }
          if (Array.isArray(data.contacts)) {
            data.contacts.forEach((contact: any) => {
              if (contact.name.toLowerCase().includes(inputValue.toLowerCase()) ||
                  contact.email.toLowerCase().includes(inputValue.toLowerCase()) ||
                  contact.phone.toLowerCase().includes(inputValue.toLowerCase())) {
                customerOptions.push({ label: contact.name, value: id });
              }
            });
          }
        });
  
        setCustomers(customerOptions);
      };
  
      fetchCustomers();
    }, [inputValue, customerId]);

    const cardStyle = { margin: '10px' };
  
    return (
      <div>
        <h3>Recent Searches</h3>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', paddingBottom: '10px' }}>
          {recentSearches.map((search, index) => (
            <div 
              key={index} 
              onClick={() => handleCustomerChange(search)}
              style={{ cursor: 'pointer', backgroundColor: 'var(--bs-secondary-bg)', color: 'var(--bs-body-color)', padding: '5px', borderRadius: '5px' }}
            >
              {search.label}
            </div>
          ))}
        </div>
    
        <div style={{ width: '50%' }}>
          <Select
            options={customers}
            onInputChange={value => setInputValue(value)}
            onChange={handleCustomerChange}
            styles={customSelectStyles}
            placeholder="Search Customers"
            noOptionsMessage={() => 'No customers found'}
          />
        </div>
      </div>
    );
  };
  
  export default ClientSearch;